import { useEffect, useRef } from 'react'
import { Outlet, useParams } from 'react-router'
import { useNotifications } from '../hooks/api.hooks'
import { useAppStore } from '../store/app'
import { useSubscription } from '../hooks/websocket.hook'
import { emit, heartbeat } from '../contexts/websocket.context'
import { useAuth } from '../hooks/auth.hook'
import { initFastCache } from '../helpers'

function groupByProjectId(data) {
    if (!data) return {}
    return data.reduce((acc, obj) => {
        const { projectId } = obj
        if (!acc[projectId]) {
            acc[projectId] = []
        }
        acc[projectId].push(obj)
        return acc
    }, {})
}

export const WorkspaceLayout = (props: any) => {
    const { workspaceId } = useParams()
    const notificationsAPI = useNotifications()
    const actions = useAppStore((state) => state.actions)
    const interval = useRef(null)
    const { getUserId } = useAuth()

    const fetchData = async () => {
        const notifications = await notificationsAPI.getAll(workspaceId)
        actions.setNotifications(groupByProjectId(notifications))
    }

    const handleHeartbeat = () => heartbeat(workspaceId, getUserId())

    useEffect(() => {
        if (workspaceId) {
            fetchData()
            clearInterval(interval.current)
            interval.current = setInterval(handleHeartbeat, 5000)
        }
    }, [workspaceId])

    useEffect(() => {
        initFastCache()
    }, [])

    useSubscription(workspaceId)

    return <Outlet />
}
